import React from "react";
import JalRoLayout from "../components/JalRoLayout";
import { ContactSection, PageHero } from "../components/JalRoSections";

const ContactPage = () => (
  <JalRoLayout>
    <PageHero
      title="Contact Us"
      text="Call, WhatsApp, or submit the inquiry form for RO service anywhere in Delhi NCR."
    />
    <ContactSection />
  </JalRoLayout>
);

export default ContactPage;
